import { useSelector } from "react-redux";
import { StoreState } from "../../models/states/StoreState";

export function DebugInfo({ children }) {
    const showDebugInfo = useSelector((state: StoreState) => state.application.debugInfo);
    if (!showDebugInfo) return null;
    return children;
}
